// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamInjuriesGetBody = {
  teamId: string;
};

export type typeTeamInjuriesGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    hasReport: boolean;
    injuries: {
      playerId?: string | null;
      name: string;
      position?: string | null;
      status: "out" | "doubtful" | "questionable" | "probable";
      note?: string | null;
      headshotUrl?: string | null;
    }[];
  };
};

export type typeTeamInjuriesGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamInjuriesGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamInjuriesGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamInjuriesGetBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamInjuriesGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamInjuriesGetBody);
  }

  return async function postTeamInjuriesGet(
    payload: typeTeamInjuriesGetBody,
  ): Promise<typeTeamInjuriesGetOutput200 | typeTeamInjuriesGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamInjuriesGet" failed before calling the network. #cbf30f42444e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cbf30f42444e" },
        },
        data: null,
      } as typeTeamInjuriesGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/injuries-get`,
      httpMethod: "POST",
      options,
    })) as typeTeamInjuriesGetOutput200 | typeTeamInjuriesGetOutput400;
  };
}
